import React, { useState, useEffect, useContext } from "react";
import { Card, CardContent, Typography, Button, CircularProgress } from "@mui/material";
import { ThemeProvider } from "@emotion/react";
import theme from "../../../themes/theme";
import axios from "axios";
import BASE_URL from "../../../config/api";
import { AppContext } from "../../../context/AppContext";
import AdminLayout from "../../../components/AdminDashboard/AdminLayout/AdminLayout";
import { useNavigate, useParams } from "react-router-dom";
import "./CourseTasks.css";

export default function CourseTasks() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const { token } = useContext(AppContext);
  const navigate = useNavigate();

  const fetchCourses = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/courses`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const coursesWithSections = await Promise.all(
        response.data.map(async (course) => {
          const sectionsResponse = await axios.get(`${BASE_URL}/courses/${course._id}/sections`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          const sectionsWithLessons = await Promise.all(
            sectionsResponse.data.map(async (section) => {
              const lessonsResponse = await axios.get(`${BASE_URL}/courses/${course._id}/sections/${section._id}/lessons`, {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              });

              return { ...section, lessons: lessonsResponse.data };
            })
          );

          return { ...course, sections: sectionsWithLessons };
        })
      );

      setCourses(coursesWithSections);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleLessonClick = (courseId, sectionId, lessonId) => {
    navigate(`/course/${courseId}/section/${sectionId}/lesson/${lessonId}/tasks`);
  };

  useEffect(() => {
    if (token) fetchCourses();
  }, [token]);

  return (
    <AdminLayout>
      <div className="courses-tasks">
        {loading ? (
          <CircularProgress />
        ) : courses && courses.length > 0 ? (
          courses.map((course) => (
            <Card key={course._id} sx={{ minWidth: "40%" }}>
              <CardContent>
                <p className="tasks-coruse-title">{course.title}</p>
                {course.sections && course.sections.length > 0 ? (
                  <ul>
                    {course.sections.map((section) => (
                      <li key={section._id}>
                        <p className="sections-list">{section.title}</p>
                        {section.lessons && section.lessons.length > 0 ? (
                          <ul className="lessons-list">
                            {section.lessons.map((lesson) => (
                              <li className="listed-lessons" key={lesson._id} onClick={() => handleLessonClick(course._id, section._id, lesson._id)}>
                                {lesson.title}
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <Typography variant="body2" color="text.secondary">
                            No lessons available for this section
                          </Typography>
                        )}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <Typography variant="body2" color="text.secondary">
                    No sections available for this course
                  </Typography>
                )}
              </CardContent>
            </Card>
          ))
        ) : (
          <>
            <Typography variant="body2" color="text.secondary" className="no-courses">
              No courses available
            </Typography>
            <ThemeProvider theme={theme}>
              {/* <Button variant="contained" sx={{ padding: "0px -2px", width: "10%" }}>
                Create new course
              </Button> */}
            </ThemeProvider>
          </>
        )}
      </div>
    </AdminLayout>
  );
}
